<template>
  <div class="div_one">

    <el-row style="background: #fff; padding: 20px 0; border-radius: 10px">
      <el-col :span="4">
        <el-select
          size="mini"
          placeholder="所属站"
          v-model="stationCode"
          @change="getStationCode"
        >
          <el-option
            v-for="item in stationsForSelect"
            :key="item.id"
            v-bind:label="item.stationName"
            v-bind:value="item.stationCode"
          ></el-option>
        </el-select>
      </el-col>
    </el-row>

    <div class="tit">今日数据信息</div>
    <el-row >
      <el-col :span="5" class="list" style="margin-left: 30px;">
          <div class="list_box">

            <div class="tits">今日总收入<el-tooltip class="item" effect="dark" content="该运营商下所有站点，今日的已完成订单中，用户实付金额加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ totalFee }}<span>元</span></div>
          </div>
          <img src="../images/list1.png" alt="">
      </el-col>
      <el-col :span="5" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">电费收入<el-tooltip class="item" effect="dark" content="该运营商下所有站点，今日的已完成订单中，电费加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ totalElectricityFee }} <span>元</span></div>
          </div>
          <img src="../images/list2.png" alt="">
      </el-col>
      <el-col :span="5" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">今日服务费收入<el-tooltip class="item" effect="dark" content="该运营商下所有站点，今日的已完成订单中，用户实付金额加总后减去电费加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ serviceFee }} <span>元</span></div>
          </div>
          <img src="../images/list3.png" alt="">
      </el-col>
      <el-col :span="5" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">今日充电量<el-tooltip class="item" effect="dark" content="该运营商下所有站点，今日的已完成订单中，充电量加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ totalElectricity }} <span>度</span></div>
          </div>
          <img src="../images/list4.png" alt="">
      </el-col>
    </el-row>
    <el-row  style="margin-top: 21px;">
      <el-col :span="5" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">今日订单数<el-tooltip class="item" effect="dark" content="该运营商下所有站点，今日的已完成订单数量加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ orderNum }} <span>单</span></div>
          </div>
          <img src="../images/list5.png" alt="">
      </el-col>
      <el-col :span="5" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">今日充电时长<el-tooltip class="item" effect="dark" content="该运营商下所有站点，今日的已完成订单中，充电时长加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ (chargeLength/3600).toFixed(2) }}<span>小时</span></div>
          </div>
          <img src="../images/list6.png" alt="">
      </el-col>
    </el-row>
    <div class="tit">统计数据

      <el-cascader
      size="mini"
    v-model="time"
    :options="options"
    :props="{ expandTrigger: 'hover' }"
    @change="handleChange"></el-cascader>
    </div>
    <el-row style="margin-top: 21px;">
      <el-col :span="4" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">总收入<el-tooltip class="item" effect="dark" content="该运营商下所有站点，统计周期内的已完成订单中，用户实付金额加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ alltotalFee }} <span>元</span></div>
          </div>
          <img src="../images/list7.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">总电费收入<el-tooltip class="item" effect="dark" content="该运营商下所有站点，统计周期内的已完成订单中，电费加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ alltotalElectricityFee }}<span>元</span></div>
          </div>
          <img src="../images/list8.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">总服务费收入<el-tooltip class="item" effect="dark" content="该运营商下所有站点，统计周期内的已完成订单中，用户实付金额加总后减去电费加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ allserviceFee }} <span>元</span></div>
          </div>
          <img src="../images/list9.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">总充电量<el-tooltip class="item" effect="dark" content="该运营商下所有站点，统计周期内的已完成订单中，充电量加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ alltotalElectricity }}<span>度</span></div>
          </div>
          <img src="../images/list10.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">总订单数<el-tooltip class="item" effect="dark" content="该运营商下所有站点，统计周期内的已完成订单数量加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ allorderNum }} <span>单</span></div>
          </div>
          <img src="../images/list11.png" alt="">
      </el-col>
    </el-row>
    <el-row style="margin-top: 21px;">

      <el-col :span="4" class="list" style="margin-left: 30px;">
          <div class="list_box">
            <div class="tits">总充电时长<el-tooltip class="item" effect="dark" content="该运营商下所有站点，统计周期内的已完成订单中，充电时长加总" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ (allchargeLength/3600).toFixed(2) }} <span>小时</span></div>
          </div>
          <img src="../images/list12.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">日均单枪充电量<el-tooltip class="item" effect="dark" content="日均单枪充电时长/24*100%" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ avgElectricity }}<span>度</span></div>
          </div>
          <img src="../images/list14.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">日均单枪充电时长<el-tooltip class="item" effect="dark" content="总充电时长/枪数/统计周期包含的天数" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ avgChargeLength }}<span>小时</span></div>
          </div>
          <img src="../images/list13.png" alt="">
      </el-col>
      <el-col :span="4" class="list" style="margin-left: 13px;">
          <div class="list_box">
            <div class="tits">日均单枪利用率<el-tooltip class="item" effect="dark" content="日均单枪充电时长/24*100%" placement="top-start">
              <img src="../images/tan.png" alt="" class="tan">
            </el-tooltip></div>
            <div class="money">{{ useRate }}<span></span></div>
          </div>
          <img src="../images/list14.png" alt="">
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" style="margin-left: 30px;">
        <div >
          <div class="headline">设备信息</div>
          <div class="flex">
              <div class="progress">
                <el-progress type="circle" :width=58 :percentage="(chargingGunNum/totalGunNum*100)"
                             v-if="!isNaN((chargingGunNum/totalGunNum*100))"
                             :show-text=false color="#5D98F5" ></el-progress>
                <div class="dashed">{{ chargingGunNum }}</div>
                <div>充电中</div>
              </div>
              <div class="progress">
                <el-progress type="circle" :width=58  :percentage="(freeGunNum/totalGunNum*100)"
                             v-if="!isNaN((freeGunNum/totalGunNum*100))"
                             :show-text=false color="#62C9B9" ></el-progress>
                <div class="dashed" style="border: 1px dashed #72D4B7;">{{ freeGunNum }}</div>
                <div>空闲</div>
              </div>
              <div class="progress">
                <el-progress type="circle" :width=58  :percentage="(offlineGunNum/totalGunNum*100)"
                             v-if="!isNaN((offlineGunNum/totalGunNum*100))"
                             :show-text=false color="#BBBBBB" ></el-progress>
                <div class="dashed" style="border: 1px dashed #C7C7C7;">{{ offlineGunNum }}</div>
                <div>离线</div>
              </div>
              <div class="progress">
                <el-progress type="circle" :width=58  :percentage="(badGunNum/totalGunNum*100)"
                             v-if="!isNaN((badGunNum/totalGunNum*100))"
                             :show-text=false color="#F19D50" ></el-progress>
                <div class="dashed" style="border: 1px dashed #F3AB69;">{{ badGunNum }}</div>
                <div>故障</div>
              </div>
            <div class="progress">
              <el-progress type="circle" :width=58  :percentage="(unfreeGunNum/totalGunNum*100)"
                           v-if="!isNaN((unfreeGunNum/totalGunNum*100))"
                           :show-text=false color="#88D1E5" ></el-progress>
              <div class="dashed" style="border: 1px dashed #88D1E5;">{{ unfreeGunNum }}</div>
              <div>占用</div>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 新增：尖峰平谷电量 -->
      <el-col :span="10" style="margin-left: 30px;">
        <div class="headline">尖峰平谷电量</div>
        <div class="div_margin">
          <div class="st-gbox" style="width: 100%; height: 200px;">
            <div class="cavasbox" id="IncomeEchart"></div>
          </div>
        </div>
      </el-col>

    </el-row>
    <el-row>
      <el-col :span="10" style="margin-left: 30px;">
        <div class="headline">收入走势</div>
        <div id="echarts_main" style="width: 100%; height: 200px; margin-left: 20px;"></div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="10" style="margin-left: 30px;">
        <div class="headline">电量走势</div>
        <div id="echarts_dianliang" style="width: 100%; height: 200px; margin-left: 20px;"></div>
      </el-col>
      <el-col :span="10" style="margin-left: 30px;">
        <div class="headline">订单走势</div>
        <div id="echarts_dingdan" style="width: 90%; height: 200px; margin-left: 10px;"></div>
      </el-col>
    </el-row>

  </div>
</template>

<script type="text/ecmascript-6">
import Chart from "echarts";
import operatingViewOperatorApi from "../../monitoringCenter/api/operatingViewOperatorApi";
import { second2Time } from "@/common/validUtil.js";
import comApi from "@/common/api/commonApi.js";
import getters from "../../../vuex/getters";
import commonApi from '../../resourceCenter/api/commonApi'

export default {
  name: "OperatingViewOperator",
  data() {
    return {
      operatorForSelect: [],
      operatorId: '',
      stationCode: '',
      stationsForSelect:[],
      options:[],
      time:[],
      companyName:[],
      companyCode:[],
      platOrderListdianliang : [],
      platOrderListshouru : [],
      platOrderListdindan : [],
      MA005DBW1dianliang : [],
      MA005DBW1shouru : [],
      MA005DBW1dindan : [],
      MA4KUHJ97dianliang : [],
      MA4KUHJ97tshouru : [],
      MA4KUHJ97dindan : [],
      MA5FF58R7dianliang : [],
      MA5FF58R7shouru : [],
      MA5FF58R7dindan : [],
      MA25CNM38dianliang : [],
      MA25CNM38shouru : [],
      MA25CNM38dindan : [],
      day : [],
      totalGunNum:0,
      freeGunNum:0,
      offlineGunNum:0,
      badGunNum:0,
      chargingGunNum:0,
      unfreeGunNum:0,
      totalFee:'',
      totalElectricityFee:'',
      serviceFee:'',
      totalElectricity:'',
      orderNum:'',
      chargeLength:'',
      alltotalFee:'',
      alltotalElectricityFee:'',
      allserviceFee:'',
      alltotalElectricity:'',
      allorderNum:'',
      allchargeLength:'',
      avgChargeLength:'',
      useRate:'',
      avgElectricity:''
    };
  },
  // 导入组件
  components: {},
  computed:{
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.loadForSelect();
  },
  watch: {
    '$store.state.operatorId': {
      handler: function (newVal, oldVal) {
        this.loadForSelect();
        this.getDay();
        this.getshuju();
      },
      deep: true
    }
},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getCompanyCodeAndName()
  },
  methods: {
    // 尖峰平谷饼图
    getIncomeEchart(value) {
      let totalSharpElectricity = value.totalSharpElectricity ? value.totalSharpElectricity: 0;
      let totalPeakElectricity = value.totalPeakElectricity ? value.totalPeakElectricity :0;
      let totalFlatElectricity = value.totalFlatElectricity ? value.totalFlatElectricity:0;
      let totalValleyElectricity = value.totalValleyElectricity ? value.totalValleyElectricity :0;

      this.chart = Chart.init(document.getElementById("IncomeEchart"));
      this.chart.setOption({
        tooltip: { trigger: "item" },
        legend: {
          orient: "vertical",
          x: "left",
          top: "8%",
          data: ["尖", "峰", "平", "谷"],
        },
        series: [
          {
            name: "充电电量",
            type: "pie",
            radius: ["40%", "50%"],
            label: {
              normal: {
                formatter: "{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ",
                backgroundColor: "#eee",
                borderColor: "#aaa",
                borderWidth: 1,
                borderRadius: 4,
                rich: {
                  a: { color: "#999", lineHeight: 16, align: "center" },
                  hr: { borderColor: "#aaa", width: "100%", borderWidth: 0.5, height: 0 },
                  b: { fontSize: 12, lineHeight: 28 },
                  per: { color: "#eee", backgroundColor: "#334455", padding: [2, 4], borderRadius: 2 },
                },
              },
            },
            data: [
              { value: totalSharpElectricity, name: "尖", itemStyle: { color: "#ff4d4d" } },
              { value: totalPeakElectricity, name: "峰", itemStyle: { color: "#ffbc2e" } },
              { value: totalFlatElectricity, name: "平", itemStyle: { color: "#43c26e" } },
              { value: totalValleyElectricity, name: "谷", itemStyle: { color: "#409eff" } },
            ],
          },
        ],
      });
    },

    getStationCode(newValue,oldValue) {
      if (newValue !== oldValue) {
        this.getDay()
        this.getshuju()
      }
    },

     getTimeList(value){
       operatingViewOperatorApi.getOperatorBusinessOfDateTypeByLabelTree(value).then((res) =>{
         this.options = res.data
         this.time = [res.data[1].value,res.data[1].children[0].value]
         this.getDay()
         this.getshuju()
       })
     },

    /**
     * 获取充电站
     */
    loadForSelect() {
      this.operatorId=sessionStorage.getItem('operatorId')
      commonApi.stationsForSelectByOperatorId([this.operatorId]).then(
        (res) => {
          if (res.code === 0) {
            this.stationsForSelect = res.data;
            this.stationCode=this.stationsForSelect[0].stationCode
            this.getTimeList(this.stationCode)
          }
        }
      );
    },


    getCompanyCodeAndName(){
      this.companyName.push("充小兽")
      this.companyCode.push()
      this.companyName.push('其他')
      this.companyCode.push("other")
      comApi.getCompanyCodeAndName().then((res) => {
        let  companyInfo=res
        for(const key in companyInfo) {
          this.companyName.push(companyInfo[key])
          this.companyCode.push(key)
        }
      })
    },

    getDay(){
      let param = {
        operatorId: this.operatorId,
        stationCode:this.stationCode,
        dateType:'day'
      }
      operatingViewOperatorApi.operatorBusinessStatistics(param).then((res)=>{
        this.totalGunNum = res.data.operatorRes.gunHour.totalGunNum
        this.freeGunNum = res.data.operatorRes.gunHour.freeGunNum
        this.offlineGunNum = res.data.operatorRes.gunHour.offlineGunNum
        this.badGunNum = res.data.operatorRes.gunHour.badGunNum
        this.chargingGunNum = res.data.operatorRes.gunHour.chargingGunNum
        this.unfreeGunNum = res.data.operatorRes.gunHour.unfreeGunNum
        this.totalFee = res.data.operatorOrder.totalOrder.totalFee
        this.totalElectricityFee = res.data.operatorOrder.totalOrder.totalElectricityFee
        this.serviceFee = res.data.operatorOrder.totalOrder.serviceFee
        this.totalElectricity = res.data.operatorOrder.totalOrder.totalElectricity
        this.orderNum = res.data.operatorOrder.totalOrder.orderNum
        this.chargeLength = res.data.operatorOrder.totalOrder.chargeLength
        let totalOrder=res.data.operatorOrder.totalOrder
        this.getIncomeEchart(totalOrder)
      })
    },
    handleChange(e){
      this.getshuju()
    },
    getshuju(){
      let param = {
        operatorId: this.operatorId,
        stationCode:this.stationCode,
        dateType:this.time[0],
        beginTime:this.time[1]
      }
      operatingViewOperatorApi.operatorBusinessStatisticsByTime(param).then((res)=>{
        console.log(res)
        this.alltotalFee = res.data.totalOrder.totalFee
        this.alltotalElectricityFee = res.data.totalOrder.totalElectricityFee
        this.allserviceFee = res.data.totalOrder.serviceFee
        this.alltotalElectricity = res.data.totalOrder.totalElectricity
        this.allorderNum = res.data.totalOrder.orderNum
        this.allchargeLength = res.data.totalOrder.chargeLength
        this.avgChargeLength = res.data.avgData.avgChargeLength
        this.useRate = res.data.avgData.useRate
        this.avgElectricity = res.data.avgData.avgElectricity
        let totalOrder = res.data.totalOrder
          let platOrderListdianliang = []
          let platOrderListshouru = []
          let platOrderListdindan = []
          let MA005DBW1dianliang = []
          let MA005DBW1shouru = []
          let MA005DBW1dindan = []
          let MA4KUHJ97dianliang = []
          let MA4KUHJ97tshouru = []
          let MA4KUHJ97dindan = []
          let MA5FF58R7dianliang = []
          let MA5FF58R7shouru = []
          let MA5FF58R7dindan = []
          let MA25CNM38dianliang = []
          let MA25CNM38shouru = []
          let MA25CNM38dindan = []
          let day = []

        for (var i = 0; i < res.data.platOrderList.length; i++) {
        platOrderListdianliang.push(res.data.platOrderList[i].totalElectricity)
        platOrderListshouru.push(res.data.platOrderList[i].totalFee)
        platOrderListdindan.push(res.data.platOrderList[i].orderNum)
        day.push(res.data.platOrderList[i].day)
      }
      //  快电
      for (var i = 0; i < res.data.MA005DBW1.length; i++) {
        MA005DBW1dianliang.push(res.data.MA005DBW1[i].totalElectricity)
        MA005DBW1shouru.push(res.data.MA005DBW1[i].totalFee)
        MA005DBW1dindan.push(res.data.MA005DBW1[i].orderNum)
      }
      //  加电
      for (var i = 0; i < res.data.other.length; i++) {
        MA4KUHJ97dianliang.push(res.data.other[i].totalElectricity)
        MA4KUHJ97tshouru.push(res.data.other[i].totalFee)
        MA4KUHJ97dindan.push(res.data.other[i].orderNum)
      }
      //  星络
      for (var i = 0; i < res.data["101437000"].length; i++) {
        MA5FF58R7dianliang.push(res.data["101437000"][i].totalElectricity)
        MA5FF58R7shouru.push(res.data["101437000"][i].totalFee)
        MA5FF58R7dindan.push(res.data["101437000"][i].orderNum)
      }
      //  新电途
      for (var i = 0; i < res.data.MA25CNM38.length; i++) {
        MA25CNM38dianliang.push(res.data.MA25CNM38[i].totalElectricity)
        MA25CNM38shouru.push(res.data.MA25CNM38[i].totalFee)
        MA25CNM38dindan.push(res.data.MA25CNM38[i].orderNum)
      }
          this.platOrderListdianliang = platOrderListdianliang
          this.platOrderListshouru = platOrderListshouru
          this.platOrderListdindan = platOrderListdindan
          this.MA005DBW1dianliang = MA005DBW1dianliang
          this.MA005DBW1shouru = MA005DBW1shouru
          this.MA005DBW1dindan = MA005DBW1dindan
          this.MA4KUHJ97dianliang = MA4KUHJ97dianliang
          this.MA4KUHJ97tshouru = MA4KUHJ97tshouru
          this.MA4KUHJ97dindan = MA4KUHJ97dindan
          this.MA5FF58R7dianliang = MA5FF58R7dianliang
          this.MA5FF58R7shouru = MA5FF58R7shouru
          this.MA5FF58R7dindan = MA5FF58R7dindan
          this.MA25CNM38dianliang = MA25CNM38dianliang
          this.MA25CNM38shouru = MA25CNM38shouru
          this.MA25CNM38dindan = MA25CNM38dindan
          this.day = day
          this.getshouru()
          this.getIncomeEchart(totalOrder)
      })
    },
    getshouru(){
      var myChart = this.$echarts.init(document.getElementById('echarts_main'));
      var myChart1 = this.$echarts.init(document.getElementById('echarts_dianliang'));
      var myChart2 = this.$echarts.init(document.getElementById('echarts_dingdan'));
      myChart.setOption({
        legend: {
         // data: ['充小兽', '星络','快电', '新电途','加电',],
          data: this.companyName,
          top: 250,
          left: '10',
          z: 10,
          top:'90%',
          left:'25%',
          icon:'circle',
          itemWidth: 10,
		      itemHeight: 10,
        },
       grid:{
         left:'8%',
         top:'10%'
       },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.day,
          splitLine: {
              show: false
          },
        },
        yAxis: {
          x: 'center',
          type: 'value',
          axisLabel: {
            formatter: "{value}",
          },
          splitLine: {
              show: false
          },

        },
        series: [{
          name: '充小兽',
          type: 'bar',
          smooth: true,
          barWidth:10,
          itemStyle: {normal: {color:'rgba(48, 109, 244, 1)'}},
          stack:'堆叠',

          data: this.platOrderListshouru
        }, {
          name: '小桔',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(206, 227, 184, 1)'}},
          data: this.MA5FF58R7shouru
        }, {
          name: '快电',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(250, 179, 92, 1)'}},
          data: this.MA005DBW1shouru
        }, {
          name: '新电途',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(232, 86, 96, 1)'}},
          data: this.MA25CNM38shouru
        }, {
          name: '其他',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(136, 209, 229, 1)'}},
          data: this.MA4KUHJ97tshouru
        }]
      })
      myChart1.setOption({
        legend: {
          //data: ['充小兽', '星络','快电', '新电途','加电',],
          data: this.companyName,
          top: 250,
          left: '10',
          z: 10,
          top:'90%',
          left:'25%',
          icon:'circle',
          itemWidth: 10,
		      itemHeight: 10,
        },
       grid:{
         left:'8%',
         top:'10%'
       },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.day,
          splitLine: {
              show: false
          },
        },
        yAxis: {
          x: 'center',
          type: 'value',
          axisLabel: {
            formatter: "{value}",
          },
          splitLine: {
              show: false
          },

        },
        series: [{
          name: '充小兽',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          itemStyle: {normal: {color:'rgba(48, 109, 244, 1)'}},
          data: this.platOrderListdianliang
        }, {
          name: '小桔',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(206, 227, 184, 1)'}},
          data: this.MA5FF58R7dianliang
        }, {
          name: '快电',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(250, 179, 92, 1)'}},
          data: this.MA005DBW1dianliang
        }, {
          name: '新电途',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(232, 86, 96, 1)'}},
          data: this.MA25CNM38dianliang
        }, {
          name: '其他',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(136, 209, 229, 1)'}},
          data: this.MA4KUHJ97dianliang
        }]
      })
      myChart2.setOption({
        legend: {
          //data: ['充小兽', '星络','快电', '新电途','加电',],
          data: this.companyName,
          top: 250,
          left: '10',
          z: 10,
          top:'90%',
          left:'25%',
          icon:'circle',
          itemWidth: 10,
		      itemHeight: 10,
        },
       grid:{
         left:'8%',
         top:'10%'
       },
        tooltip: {
          show: true,
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.day,
          splitLine: {
              show: false
          },
        },
        yAxis: {
          x: 'center',
          type: 'value',
          axisLabel: {
            formatter: "{value}",
          },
          splitLine: {
              show: false
          },

        },
        series: [{
          name: '充小兽',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          itemStyle: {normal: {color:'rgba(48, 109, 244, 1)'}},
          data: this.platOrderListdindan
        }, {
          name: '小桔',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(206, 227, 184, 1)'}},
          data: this.MA5FF58R7dindan
        }, {
          name: '快电',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(250, 179, 92, 1)'}},
          data: this.MA005DBW1dindan
        }, {
          name: '新电途',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(232, 86, 96, 1)'}},
          data: this.MA25CNM38dindan
        }, {
          name: '其他',
          type: 'bar',
          smooth: true,
          barWidth:10,
          stack:'堆叠',
          barGap: '-100%',
          itemStyle: {normal: {color:'rgba(136, 209, 229, 1)'}},
          data: this.MA4KUHJ97tdindan
        }]
      })
    }
  },
};
</script>

<style lang="less" scoped>
.tit {
  font-size: 17px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  text-align: left;
  margin: 21px 0;
}
.list{
  height: 111px;
  background: #fff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  img{
    width: 48px;
    height: 48px;
  }
  .tan{
    width: 11px;
    height: 11px;
    margin-left: 4px;
  }
  .tits{
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    display: flex;
    align-items: center;
  }
  .money{
    text-align: left;
    font-size: 21px;
    font-family: DIN;
    font-weight: bold;
    color: #333333;
    span{
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    }
  }
}
.lists{
  height: 111px;
  background: #fff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  img{
    width: 39px;
    height: 39px;
  }
  .tan{
    width: 9px;
    height: 9px;
    margin-left: 4px;
  }
  .tits{
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    display: flex;
    align-items: center;
  }
  .money{
    text-align: left;
    font-size: 17px;
    font-family: DIN;
    font-weight: bold;
    color: #333333;
    span{
    font-size: 10px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    }
  }
}
/deep/.el-col-10{
  width: 44%;
  height: 258px;
  background: #FFFFFF;
  border-radius: 7px;
  margin-top: 22px;
}
.headline{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  padding-top: 17px ;
  padding-left: 19px;
  box-sizing: border-box;
  text-align: left;
}
.flex{
  display: flex;
  justify-content: space-around;
  margin-top: 53px;
}
/deep/.el-progress-circle{
  width: 100px !important;
  height: 100px !important;
}
.progress{
  position: relative;
}
.dashed{
  width: 60px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  border: 1px dashed #5D98F5;
  position: absolute;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  font-size: 20px;
  font-family: DIN;
  font-weight: bold;
  color: #333333;
}
.progress :last-child{
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
}

/* 尖峰平谷样式 */
.div_margin {
  margin-top: 5px;
  padding-bottom: 10px;
}
.st-gbox {
  margin-top: 0px;
  border-radius: 5px;
  height: 30vh;
  box-sizing: border-box;
  padding: 0px;
}
.cavasbox {
  box-sizing: border-box;
  width: 100%;
  height: 215px;
}
</style>



// WEBPACK FOOTER //
// src/module/monitoringCenter/page/operatingView_operator.vue